export default {"src":"/_next/static/media/icon-sales-force.14103698.svg","height":45,"width":64,"blurWidth":0,"blurHeight":0};